export const footerCopy = {
  footer_customize: "Personnaliser",
  footer_site_colours: "Couleurs du site",
  footer_code_font: "Police du code",
  footer_site_colours_options_system: "Système",
  footer_site_colours_options_always_light: "Toujours clair",
  footer_site_colours_options_always_dark: "Toujours sombre",
}
